export const defaultStepOptions: any = {
  scrollTo: { behavior: 'smooth', block: 'center' },
  cancelIcon: {
    enabled: true,
  },
  buttons: [
    {
      text: 'Next',
      action: function () {
        return this.next();
      },
    },
    {
      text: 'Back',
      action: function () {
        return this.back();
      },
    },
    {
      text: 'Finish',
      action: function () {
        return this.complete();
      },
    },
  ],
};

export const getStepsAddProduct = (enableLoader: boolean): any[] => [
  {
    id: '1',
    title: 'Add Product',
    text: "You can access this menu by clicking the profile icon in the header, where you'll find the 'Add Product' button.",
    attachTo: {
      element: '.profilePopupMenu .nav-product button',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'Next',
        action: function () {
          document
            .getElementsByClassName('profilePopupMenu')[0]
            .getElementsByClassName('nav-product')[0]
            .getElementsByTagName('button')[0]
            ?.click();
          setTimeout(() => {
            return this.next();
          }, 100);
        },
      },
    ],
  },
  {
    id: '3',
    title: 'select category',
    text: 'Select the appropriate category for your product to help boost its visibility and increase sales.',
    attachTo: {
      element: '.category-shepherd',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'Back',
        action: function () {
          return this.back();
        },
      },
      {
        text: 'Next',
        action: function () {
          return this.next();
        },
      },
    ],
  },
  {
    id: '4',
    title: 'your region',
    text: 'You cannot modify the state selection field; it is provided solely for indicating your state.',
    attachTo: {
      element: '.region-shepherd',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'Back',
        action: function () {
          return this.back();
        },
      },
      {
        text: 'Next',
        action: function () {
          return this.next();
        },
      },
    ],
  },
  {
    id: '2',
    title: 'Select Template',
    text: "We've simplified adding product content for you. Select the relevant template that best fits your product.",
    attachTo: {
      element: '.template-shepherd',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'Next',
        action: function () {
          return this.next();
        },
      },
    ],
  },
  {
    id: '5',
    title: 'name product',
    text: 'Choose a concise product name with distinctive keywords to enhance its visibility in search engine results.',
    attachTo: {
      element: '.name-shepherd',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'Back',
        action: function () {
          return this.back();
        },
      },
      {
        text: 'Next',
        action: function () {
          return this.next();
        },
      },
    ],
  },
  {
    id: '6',
    title: 'details product',
    text: 'Here, you can provide the product description, specify where it is sold, and include details about its price.',
    attachTo: {
      element: '.details-product-shepherd',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'Back',
        action: function () {
          return this.back();
        },
      },
      {
        text: 'Next',
        action: function () {
          return this.next();
        },
      },
    ],
  },
  {
    id: '7',
    title: 'more details product',
    text: 'Here, you can upload product images and provide seller information.',
    attachTo: {
      element: '.more-details-product-shepherd',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'Back',
        action: function () {
          return this.back();
        },
      },
      {
        text: 'Next',
        action: function () {
          return this.next();
        },
      },
    ],
  },
  {
    id: '8',
    title: 'select unit',
    text: 'Define the unit of measurement (e.g., pieces, liters, kilograms).',
    attachTo: {
      element: '.unit-shepherd',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'Back',
        action: function () {
          return this.back();
        },
      },
      {
        text: 'End',
        action: function () {
          return this.next();
        },
      },
    ],
  },
];

export const stepsVerifyEmail: any = [
  {
    id: '1',
    title: 'Verify',
    text: 'Our rewards system allows users to earn points for various activities on the site. Here’s how you can accumulate points',
    attachTo: {
      element: '.verify-shepherd',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'Next',
        action: function () {
          const verifyButton = document
          .getElementsByClassName('left-menu')[0]
          ?.getElementsByClassName('verify-shepherd')[0];
        
        if (verifyButton instanceof HTMLElement) {
          verifyButton.click();
        }
        setTimeout(() => {
          return this.next();
        }, 100);
        },
      },
    ],
  },
  {
    id: '2',
    text: 'If you want instructions on each point, you can click on the info icon.',
    attachTo: {
      element: '.verify-content-shepherd',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'End',
        action: function () {
          return this.next();
        },
      },
    ],
  },
];


export const stepsProfile: any = [
  {
    id: '1',
    title: 'Quests',
    text: 'Our rewards system allows users to earn points for various activities on the site. Here’s how you can accumulate points',
    attachTo: {
      element: '.quests-Shepherd',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'Next',
        action: function () {
          return this.next();
        },
      },
    ],
  },
  {
    id: '2',
    text: 'If you want instructions on each point, you can click on the info icon.',
    attachTo: {
      element: '.info-Shepherd',
      on: 'top',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'End',
        action: function () {
          return this.next();
        },
      },
    ],
  },
];

export const stepsSuggestionProduct = (enableLoader: boolean): any[] => [
  {
    id: '1',
    title: 'Cart Product',
    text: 'Click on the image or title to open a pop-up window with product details, where you can also submit your suggestions.',
    attachTo: {
      element: '.my-card',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'Next',
        action: function () {
          const card = document.getElementsByClassName('my-card')[0];
          if (card) {
            const img = card.getElementsByTagName('img')[0];
            if (img) {
              img.click();
              setTimeout(() => {
                this.next();
              }, 3000);
            }
          }
        },
      },
    ],
  },
  {
    id: '2',
    title: 'List buttons',
    text: 'This list includes several options, such as the ability to submit a suggestion.',
    attachTo: {
      element: '.my-btn-list',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'Next',
        action: function () {
          const btn: any = document.querySelector('.my-btn-list');
          btn.click();
          setTimeout(() => {
            return this.next();
          }, 100);
        },
      },
    ],
  },
  {
    id: '3',
    title: 'suggest button',
    text: 'From there, you can submit a suggestion. Please provide feedback that will help us enhance and improve the service.',
    attachTo: {
      element: '.suggest-shepherd',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'Next',
        action: function () {
          const btn: any = document.querySelector('.suggest-shepherd');
          btn.click();
          setTimeout(() => {
            return this.next();
          }, 100);
        },
      },
    ],
  },
];

export const stepsFavoritesProduct: any = [
  {
    id: '1',
    title: 'add a product to your favorites',
    text: "click the heart to add your favorite products to help us understand your interests and offer you more personalized recommendations. Additionally, you'll be able to view your favorites on your page.",
    attachTo: {
      element: '.my-card .fa-heart',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'End',
        action: function () {
          return this.next();
        },
      },
    ],
  },
];

export const stepsCreateNews: any = [
  {
    id: '1',
    title: 'Create a new Articales',
    text: 'Create a new article to earn more points.',
    attachTo: {
      element: '.news-hero__card .button-3.white',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'Next',
        action: function () {
          document
            .getElementsByClassName('news-hero__card')[0]
            .getElementsByTagName('button')[0]
            ?.click();
          setTimeout(() => {
            return this.next();
          }, 100);
        },
      },
    ],
  },
  {
    id: '2',
    title: 'article image',
    text: 'Add an eye-catching image to your article to boost viewership and increase profits. Aim for an image with dimensions close to 1280 x 767 pixels.',
    attachTo: {
      element: '.form-blog .upload-image',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'Next',
        action: function () {
          return this.next();
        },
      },
    ],
  },
  {
    id: '3',
    title: 'Name',
    text: 'Add a relevant title with key terms to help promote your article in search engines.',
    attachTo: {
      element: '.form-blog .title-shepherd',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'Back',
        action: function () {
          return this.back();
        },
      },
      {
        text: 'Next',
        action: function () {
          return this.next();
        },
      },
    ],
  },
  {
    id: '4',
    title: 'Editor',
    text: 'Include detailed content with well-defined titles and descriptions for each section, and use sub-titles to organize the information effectively.',
    attachTo: {
      element: '.form-blog .editor-shepherd',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'Back',
        action: function () {
          return this.back();
        },
      },
      {
        text: 'Next',
        action: function () {
          return this.next();
        },
      },
    ],
  },
  {
    id: '5',
    title: 'Writer',
    text: 'Add a name or nickname to enhance credibility.',
    attachTo: {
      element: '.form-blog .author-shepherd',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'Back',
        action: function () {
          return this.back();
        },
      },
      {
        text: 'Next',
        action: function () {
          return this.next();
        },
      },
    ],
  },
  {
    id: '6',
    title: 'category',
    text: 'Select the appropriate category for your article.',
    attachTo: {
      element: '.form-blog .category-shepherd',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'Back',
        action: function () {
          return this.back();
        },
      },
      {
        text: 'End',
        action: function () {
          return this.next();
        },
      },
    ],
  },
];

export const stepsCreateForum: any = [
  {
    id: '1',
    title: 'Create a new forum',
    text: 'this button for add product',
    attachTo: {
      element: '.my-card .fa-heart',
      on: 'bottom',
    },
    classes: 'step-learn',
    buttons: [
      {
        text: 'End',
        action: function () {
          return this.next();
        },
      },
    ],
  },
];
